//     
import React from 'react';

import Icon from 'components/Icon';

import { mergeClassNames } from 'utils/functions';

const Checkbox = ({
    checked,
    disabled = false,
    onChange,
    label = '',
    error,
    ...domProps
}   
                     
                      
                              
                  
                   
 ) => {
    const className = mergeClassNames(
        domProps.className || 'mr-4',
        'checkbox',
        checked ? 'checked': '',
        disabled ? 'text-muted' : ''
    );

    let iconColor = 'secondary';
    if (disabled) {
        iconColor = 'muted';
    } else if (checked) {
        iconColor = 'success';
    }

    return (
        <span
            style={{ cursor: 'pointer' }}
            {...domProps}
            onClick={() => {
                if (!disabled) {
                    onChange(!checked);
                }
            }}
            className={className}
        >
            <Icon
                tabIndex='0'
                name={checked ? 'check-square' : 'square'}
                className={`text-${iconColor} mr-2`}
            />
            {label && label}
            {error && <small className='form-text text-danger'>{error}</small>}
        </span>
    );
};


export default Checkbox;
